/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RewardSettings
 */
export interface RewardSettings {
    /**
     * 
     * @type {number}
     * @memberof RewardSettings
     */
    packagePoints: number;
    /**
     * 
     * @type {number}
     * @memberof RewardSettings
     */
    recruitedPoints: number;
    /**
     * 
     * @type {number}
     * @memberof RewardSettings
     */
    shippedPoints: number;

    phoneVerifiedPoints: number;
    /**
     * Points required to redeem one unit of the courier's currency (100 = "100 points = $1").
     * 0 means redemption is not configured. Optional in the SDK so an app built against a
     * newer model still parses responses from an API that predates the column.
     * @type {number}
     * @memberof RewardSettings
     */
    pointsPerCurrencyUnit?: number;
    /**
     * 
     * @type {number}
     * @memberof RewardSettings
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof RewardSettings
     */
    courierId?: number;
}

/**
 * Check if a given object implements the RewardSettings interface.
 */
export function instanceOfRewardSettings(value: object): value is RewardSettings {
    if (!('packagePoints' in value) || value['packagePoints'] === undefined) return false;
    if (!('recruitedPoints' in value) || value['recruitedPoints'] === undefined) return false;
    if (!('shippedPoints' in value) || value['shippedPoints'] === undefined) return false;
    if (!('phoneVerifiedPoints' in value) || value['phoneVerifiedPoints'] === undefined) return false;
    return true;
}

export function RewardSettingsFromJSON(json: any): RewardSettings {
    return RewardSettingsFromJSONTyped(json, false);
}

export function RewardSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'packagePoints': json['packagePoints'],
        'recruitedPoints': json['recruitedPoints'],
        'shippedPoints': json['shippedPoints'],
        'phoneVerifiedPoints': json['phoneVerifiedPoints'],
        'pointsPerCurrencyUnit': json['pointsPerCurrencyUnit'] == null ? undefined : json['pointsPerCurrencyUnit'],
        'id': json['id'] == null ? undefined : json['id'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
    };
}

export function RewardSettingsToJSON(json: any): RewardSettings {
    return RewardSettingsToJSONTyped(json, false);
}

export function RewardSettingsToJSONTyped(value?: RewardSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'packagePoints': value['packagePoints'],
        'recruitedPoints': value['recruitedPoints'],
        'shippedPoints': value['shippedPoints'],
        'phoneVerifiedPoints': value['phoneVerifiedPoints'],
        'pointsPerCurrencyUnit': value['pointsPerCurrencyUnit'],
        'id': value['id'],
        'courierId': value['courierId'],
    };
}

